import { useRef, useState, ChangeEvent, FC, useEffect } from 'react'
import { Button, Spin, Col, Row } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useDownload, useTicketsById } from '@hooks'

import { StyledRow, StyledSelectLabel } from '../StyledComponents'
import useTicketFiles from './hooks'

const TicketFilesVariantForm: FC = () => {
  const { ticketById, ticketFiles } = useTicketsById()
  const [fileUrl, setFileUrl] = useState<string | undefined>()
  const [onlyDownload, setOnlyDownload] = useState(false)
  const linkRef = useRef(null)
  const { uploadFile, getFile, isLoading } = useTicketFiles()
  const { t } = useTranslation()

  const { downloadFile, isLoading: isDownloading, keyDowloading } = useDownload()

  const handleUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) {
      return
    }
    const filePayload = {
      ticketId: ticketById?.ticket?.id && ticketById?.ticket?.id,
      ticketFile: file,
    }
    uploadFile(filePayload)
  }

  const handleOpenFile = (fileId: number) => {
    getFile(fileId, {
      onSuccess: (data: { fileToDownload: string }) => {
        setFileUrl(data.fileToDownload)
      },
    })
  }

  useEffect(() => {
    if (fileUrl && linkRef.current) {
      const linkReference = linkRef.current as unknown as HTMLAnchorElement
      linkReference.click()
    }
  }, [fileUrl])

  return (
    <StyledRow>
      <Col
        span={8}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingRight: '4px',
        }}
      >
        <p style={{ marginBottom: 0, marginTop: 'unset' }}>{t('ticket_modal.attachments')}:</p>
      </Col>
      {isLoading ? (
        <Spin spinning />
      ) : (
        <Col className="carrier-form-row" style={{ paddingLeft: '0.5rem' }} span={16}>
          <div style={{ paddingRight: '1rem' }}>
            <input
              hidden
              onChange={handleUpload}
              type="file"
              id="file-select"
              style={{ display: 'none' }}
            />
            <StyledSelectLabel htmlFor="file-select">
              {t('ticket_modal.attach_files')}
            </StyledSelectLabel>
          </div>
          {ticketFiles?.map(fileMapped => (
            <Row justify="space-between" align="middle" key={fileMapped.id}>
              <Button
                onClick={() => handleOpenFile(fileMapped.id)}
                type="link"
                block
                size="small"
                style={{ paddingLeft: 0, paddingRight: 0 }}
              >
                <Row justify="space-between" align="middle">
                  {fileMapped.fileName.length > 25
                    ? `${fileMapped.fileName.slice(0, 25)}...`
                    : fileMapped.fileName}

                  {isDownloading && keyDowloading === fileMapped.ticketFile ? (
                    <Spin spinning size="small" />
                  ) : (
                    <DownloadOutlined
                      onClick={() => {
                        downloadFile({ key: fileMapped.ticketFile!, name: fileMapped.fileName })
                        setOnlyDownload(true)
                      }}
                    />
                  )}
                </Row>
              </Button>
            </Row>
          ))}
          {!ticketFiles?.length && <p>{t('ticket_modal.no_attachments_uploaded')}</p>}
          {fileUrl && !onlyDownload && (
            <Link to={fileUrl} ref={linkRef} target="_blank" rel="noopener noreferrer" />
          )}
        </Col>
      )}
    </StyledRow>
  )
}

export { TicketFilesVariantForm }
